/**
 * Global middleware для страниц раздела /lk
 * Добавляет класс .lk-page к body для управления стилями
 */
export default defineNuxtRouteMiddleware((to, _from) => {
  if (process.client) {
    const isLkPage = to.path.startsWith('/lk')
    
    if (isLkPage) {
      // Добавляем класс к body
      document.body.classList.add('lk-page')
      // Добавляем data-атрибут для CSS :has() селектора
      document.body.dataset.lkPage = 'true'
    } else {
      // Убираем класс при переходе на другие страницы
      document.body.classList.remove('lk-page')
      delete document.body.dataset.lkPage
    }
  }
})
